import API from '../config/api';
import React, { useState } from 'react';

import axios from 'axios';
import { toast } from 'react-toastify';
import { Card, Form, Button, Spinner, Row, Col } from 'react-bootstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

import { useNavigate, Link } from 'react-router-dom';

import { authStyles } from './ForgotPasswordPage';
import DeliveryNavbar from '../components/DeliveryNavbar';

function DeliverySignupPage() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    vehicleType: '',
    password: '',
    confirmPassword: ''
  });
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  const signupHandler = async (e) => {
    e.preventDefault();

    if (form.password !== form.confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    try {
      setLoading(true);

      await axios.post(`${API}/delivery/register`, {
        name: form.name,
        email: form.email,
        phone: form.phone,
        vehicleType: form.vehicleType,
        password: form.password
      });

      toast.success('Registered! Awaiting admin approval.');

      setTimeout(() => navigate('/delivery/login'), 1500);
    } catch (error) {
      toast.error(error.response?.data?.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <DeliveryNavbar />

      <div className="auth-wrap">
        <Card className="border-0 shadow-lg auth-card auth-card-wide">
          <Card.Body className="p-4 p-md-5">
            <div className="text-center mb-4">
              <div className="auth-icon">🛵</div>

              <h3 className="fw-bold mb-2">Become a Delivery Partner</h3>

              <p className="text-muted mb-0">
                Register below. An admin will approve your account before you
                can start delivering.
              </p>
            </div>

            <Form onSubmit={signupHandler}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold">Full Name</Form.Label>
                <div className="auth-input-group">
                  <span className="auth-input-icon">👤</span>
                  <Form.Control
                    type="text"
                    placeholder="John Doe"
                    className="auth-input"
                    value={form.name}
                    onChange={set('name')}
                    required
                    autoFocus
                  />
                </div>
              </Form.Group>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">Email</Form.Label>
                    <div className="auth-input-group">
                      <span className="auth-input-icon">✉️</span>
                      <Form.Control
                        type="email"
                        placeholder="you@example.com"
                        className="auth-input"
                        value={form.email}
                        onChange={set('email')}
                        required
                      />
                    </div>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">Phone</Form.Label>
                    <div className="auth-input-group">
                      <span className="auth-input-icon">📱</span>
                      <Form.Control
                        type="tel"
                        placeholder="9876543210"
                        className="auth-input"
                        value={form.phone}
                        onChange={set('phone')}
                        required
                      />
                    </div>
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold">Vehicle Type</Form.Label>
                <div className="auth-input-group">
                  <span className="auth-input-icon">🛺</span>
                  <Form.Select
                    className="auth-input"
                    value={form.vehicleType}
                    onChange={set('vehicleType')}
                    required
                  >
                    <option value="">Select vehicle</option>
                    <option value="Bike">Bike</option>
                    <option value="Scooter">Scooter</option>
                    <option value="Bicycle">Bicycle</option>
                    <option value="Car">Car</option>
                    <option value="Van">Van</option>
                  </Form.Select>
                </div>
              </Form.Group>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">Password</Form.Label>
                    <div className="auth-input-group">
                      <span className="auth-input-icon">🔑</span>
                      <Form.Control
                        type={show ? 'text' : 'password'}
                        placeholder="Create password"
                        className="auth-input"
                        value={form.password}
                        onChange={set('password')}
                        required
                      />
                      <button
                        type="button"
                        className="auth-eye"
                        onClick={() => setShow((s) => !s)}
                        aria-label={show ? 'Hide password' : 'Show password'}
                      >
                        {show ? <FaEyeSlash /> : <FaEye />}
                      </button>
                    </div>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-4">
                    <Form.Label className="fw-semibold">
                      Confirm Password
                    </Form.Label>
                    <div className="auth-input-group">
                      <span className="auth-input-icon">🔑</span>
                      <Form.Control
                        type={show ? 'text' : 'password'}
                        placeholder="Re-enter password"
                        className="auth-input"
                        value={form.confirmPassword}
                        onChange={set('confirmPassword')}
                        required
                      />
                    </div>
                    {form.confirmPassword &&
                      form.confirmPassword !== form.password && (
                        <small className="text-danger">
                          Passwords do not match
                        </small>
                      )}
                  </Form.Group>
                </Col>
              </Row>

              <Button
                type="submit"
                className="w-100 fw-bold auth-btn"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <Spinner size="sm" className="me-2" />
                    Registering...
                  </>
                ) : (
                  'Register as Partner'
                )}
              </Button>
            </Form>

            <div className="text-center mt-4">
              <span className="text-muted">Already a partner? </span>
              <Link to="/delivery/login" className="auth-link">
                Login
              </Link>
            </div>
          </Card.Body>
        </Card>
      </div>

      <style>{authStyles}</style>
    </>
  );
}

export default DeliverySignupPage;
